import "./App.scss";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import React, { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import WelcomeScreen from "./pages/onboarding/Welcome";
import OnboardingResult from "./pages/onboarding/OnboardingResult";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotFountError from "./pages/notfounterror/NotFountError";
import OnBoarding from "./pages/onboarding/Onboarding";
import "react-datepicker/dist/react-datepicker.css";
import OnBoardingRoot from "./pages/onboarding/Root";
import MaintenancePage from "./pages/onboarding/MaintenancePage";
import CompletionRoot from "./pages/careers/CareersRoot";
import JobListings from "./pages/careers/jobListings/JobListings";
import JobApplay from "./pages/careers/jobListings/jobapplication/JobApplay";


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import JobAlerts from "./pages/careers/jobalerts/JobAlerts";
import JobAlertUnSubscribe from "./pages/careers/JobAlertSubscriptionAndVerification/JobAlertUnSubscribe";
import VerifyEmail from "./pages/careers/JobAlertSubscriptionAndVerification/VerifyEmail";
import PatternNavigator from "./service/Navigator";


function App() {
  axios.interceptors.request.use(
    (request: any) => {
      return request;
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );
  axios.interceptors.response.use(
    (request: any) => {
      return request;
    },
    (error: any) => {

      return Promise.reject(error);
    }
  );
  const router = () => {
    return (
      <>
        <Routes>
          <Route path="getCandidate" element={<OnBoardingRoot />}>
            <Route path=":clientId" element={<WelcomeScreen />} />
            <Route path="onboarding" element={<OnBoarding />} />
            <Route path="onboarding-result" element={<OnboardingResult />} />
            <Route path="maintenance" element={<MaintenancePage />} />
          </Route>
          <Route path="" element={<CompletionRoot />}>
            <Route path="apply-job" element={<JobApplay />} />
            <Route path="job-alerts" element={<JobAlerts />} />
            <Route path="unsubscribe/:token" element={<JobAlertUnSubscribe />} />
            <Route path="verify-email/:token" element={<VerifyEmail />} />
            <Route path="" element={<JobListings />} />
            <Route path="view/:id" >
              <Route path="" element={<JobListings />} />
              <Route path="apply-job/register/from/:from" element={<JobApplay />} />
              <Route path="apply-job/from/:from" >
                <Route path="" element={<JobListings />} />
              </Route>
            </Route>
          </Route>
          <Route path="careers/*" element={<PatternNavigator to={"/"} replace />} />
          <Route path="*" element={<NotFountError />} />
        </Routes >
      </>
    );
  };

  return (
    <>
      {process.env.REACT_APP_BUILD_CONFIG === "uat" ? (
        <BrowserRouter basename="/turbo_frontend">
          {router()}
        </BrowserRouter>
      ) : process.env.REACT_APP_BUILD_CONFIG === "clientuat" ? (
        <BrowserRouter basename={process.env.REACT_APP_FOLDER_NAME}>
          {router()}
        </BrowserRouter>
      ) : process.env.REACT_APP_BUILD_CONFIG === "flk_demo" ? (
        <BrowserRouter basename="/flk_demo">
          {router()}
        </BrowserRouter>
      ) : process.env.REACT_APP_BUILD_CONFIG === "prodstaging" ? (
        <BrowserRouter>
          {router()}
        </BrowserRouter>
      ): (
        <BrowserRouter>
          {router()}
        </BrowserRouter>
      )}
      <ToastContainer position="bottom-right" theme="colored" autoClose={5000} />
    </>
  );
}

export default App;
